
// TODO - Type 'any' needs to be fixed.
export const editDraftShiftDialogCloseReducer = (state:any) => {
    state.editDraftShiftDialog.isOpen = false;
    state.editDraftShiftDialog.shiftId = null;
}